import App from 'app/app.js';
import 'app/service/ItemService.js';
import 'app/store/JobStore.js';
import 'app/store/VisualMerchandiseStore.js';
import 'app/store/ProductCatalogStore.js';

function LtPackageSummaryCtrl($scope, $timeout, JobStore, VisualMerchandiseStore, ProductCatalogStore, ItemService) {
  this.init = function () {
    $timeout(function () {
      if ($scope.isScrollable && $('#sticky').length) {
        $('#sticky').stickyfloat({
          duration: 0,
          offsetY: 0,
          parent: $('#auto-scroll')
        });
      }
    });
    var productCatalog = ProductCatalogStore.getProductCatalog();
    var thisPackage = R.find(function (pkg) {
      return pkg.skuCode === $scope.orderLine.orderable.skuCode;
    })(R.concat(productCatalog.packages, productCatalog.bundles));
    this.items = thisPackage && getPackageSheets(thisPackage).concat(getPackageProducts(thisPackage));
  };

  /**
   * Recursive method.
   * Will attempt to parse item names, will return item objects and/or if parse was successful
   *   must be in the format '(n) wxh description'
   *   examples:
   *     correct: '(1) 8x10', '(4) 3x7 Wallets', '(2) 5x7, (4) 3x7 Wallets'
   *     incorrect: '(4) Variety 3x7', '2-5x7 Individuals'
   * @param itemName - item name, ex. '(1) 8x10'
   * @param items - optionally pass previously parsed items
   * @returns {{success: boolean, items: *}}
   */

  var parseItemName = function (itemName, items) {
    // \u00C0-\u00FF (Latin-1 Supplement) to cover French and Spanish
    var regex = /\((\d+)\)\s*(\d+)[xX](\d+)([\s\w\u00C0-\u00FF]*)/;
    try {
      if (regex.test(itemName)) {
        var result = regex.exec(itemName);
        var itemObj = {
          count: parseInt(result[1]),
          width: parseInt(result[2]),
          height: parseInt(result[3]),
          description: result[4]
        };
        var allItems = !items ? [itemObj] : items.concat(itemObj);
        return parseItemName(itemName.replace(regex, ''), allItems);
      } else {
        if (itemName.replace(',', '').trim().length !== 0) {
          return { success: false };
        } else {
          return {
            success: true,
            items: items
          };
        }
      }
    } catch (e) {
      return { success: false };
    }
  };

  /**
   * Recursive method.
   * Will combine sheets based on height and width of the sheet. Will use first available description
   * @param sheets { [{count:number, height:number, width:number, description?:string} ] }
   * @param combinedSheets - optionally pass previously combined sheets
   * @returns { [{nameDesc:string, height:number, width:number}] }
   */

  var combineSheets = function (sheets, combinedSheets) {
    if (sheets.length < 1) {
      return combinedSheets;
    }
    var sheet = sheets[0];
    var matchingSheets = R.filter(function (itSheet) {
      return sheet.width === itSheet.width && sheet.height === itSheet.height;
    })(sheets);
    var otherSheets = R.filter(function (itSheet) {
      return sheet.width !== itSheet.width || sheet.height !== itSheet.height;
    })(sheets);
    // first try and use the first sheet's description, then try to find another non-empty description for the sheet size
    var sheetDescription = sheet.description;
    if (!sheetDescription) {
      var otherSheet = R.find(R.complement(R.propEq('description', '')))(matchingSheets);
      sheetDescription = otherSheet ? otherSheet.description : '';
    }
    var totalCount = R.reduce(function (acc, item) {
      return acc + item.count;
    }, 0)(matchingSheets);
    var combinedSheet = {
      nameDesc: totalCount + ' - ' + sheet.width + 'x' + sheet.height + sheetDescription,
      width: sheet.width,
      height: sheet.height
    };
    return combineSheets(otherSheets, !combinedSheets ? [combinedSheet] : combinedSheets.concat(combinedSheet));
  };

  var getPackageSheets = function (pkg) {
    var sheetItems = R.filter(function (item) {
      return item.lookSelectionAllowed && item.productCategory === 'PortSheets';
    })(pkg.items);
    var contents = R.map(function (item) {
      return {
        item: item,
        nameDesc: item.nameDesc,
        nameParse: parseItemName(item.nameDesc)
      };
    })(sheetItems);
    // filter out sheets that failed parse to show at the end of the list
    var failedSheetItems = R.filter(function (item) {
      return !item.nameParse.success;
    })(contents);
    var parsedSheets = R.reduce(function (acc, item) {
      return item.nameParse.success ? acc.concat(item.nameParse.items) : acc;
    }, [])(contents);
    // combine and sort sheets
    var combinedSheets = R.sort(function (sheetA, sheetB) {
      // sort from largest sheet size to smallest
      return sheetB.width * sheetB.height - sheetA.width * sheetA.height;
    })(combineSheets(parsedSheets) || []);
    return [].concat(combinedSheets).concat(failedSheetItems);
  };

  var getPackageProducts = function (pkg) {
    var products = R.filter(function (item) {
      return !item.lookSelectionAllowed || item.productCategory !== 'PortSheets';
    })(pkg.items);
    return R.sortBy(R.prop('nameDesc'))(products);
  };

  const hasSelectionValue = (selection) =>
    !!selection && !!selection.value && selection.value.toString().trim().length > 0;

  const hasPersonalizationValue = (item) => {
    const selections = item && item.orderLineItemSelections;
    return Array.isArray(selections) && selections.some(hasSelectionValue);
  };

  this.hasUncustomizedPersonalizerItems = () => {
    if (!$scope.orderLine || !$scope.orderLine.orderLineDetails) {
      return false;
    }

    return $scope.orderLine.orderLineDetails.some((detail) => {
      const item = detail && detail.item;
      return ItemService.isTextBasedPersonalizerEnabled(item) && !hasPersonalizationValue(item);
    });
  };

  this.saveToCart = function () {
    $scope.onSave();
  };

  this.hideDisclaimer = function () {
    return !JobStore.isPreOrder() && VisualMerchandiseStore.getVisualMerchandise().useSubjectImages;
  };
}
App.controller('LtPackageSummaryCtrl', [
  '$scope',
  '$timeout',
  'JobStore',
  'VisualMerchandiseStore',
  'ProductCatalogStore',
  'ItemService',
  LtPackageSummaryCtrl
]);
